import * as React from 'react';

import { ca } from '@cian/analytics';
import { Tooltip } from '@cian/tooltip-component';
import { TextField } from '@cian/text-field-component';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IUser } from '../../models/user';
import { digestReset, ISubmitDigestSuccess, submitDigest } from '../../redux/modules/digest/digest';
import { trackRegistration, trackSubscribe } from './tracking';

const s = require('./magazine.css');

interface IProps {
  isAuthenticated: boolean;
  email: string;
  compact: boolean;
  onDigestSubmit(email: string): Promise<ISubmitDigestSuccess>;
  onDigestReset(): void;
  isSubscribed: boolean;
  error?: string;
}

interface IState {
  value: string;
  emailValid?: boolean;
}

const isFakeEmail = /@social\.cian\.ru$/;

export class DigestForm extends React.Component<IProps, IState> {
  private static renderLicence() {
    return (
      <div className={s['c-licence']}>
        <span>При подписке вы принимаете условия </span>
        <a
          target="_blank"
          className={s['c-licence-link']}
          href="//www.cian.ru/help/about/rules/"
        >
          Пользовательского соглашения
        </a>
        {' '}и{' '}
        <a target="_blank"
           className={s['c-licence-link']}
           href="//www.cian.ru/help/about/36526/"
        >
          Политики конфиденциальности
        </a>
      </div>
    );
  }

  public constructor(props: IProps) {
    super(props);
    this.state = {
      value: isFakeEmail.test(props.email) ? '' : props.email,
      emailValid: true,
    };
  }

  public componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.isSubscribed) {
      ca('event', {
        name: 'oldevent',
        category: 'Magazine_subscription',
        action: 'Send',
        label: 'news_from_main_page',
      });
    }

    if (nextProps.email !== this.props.email && !this.state.value && nextProps.email) {
      this.setState({
        value: isFakeEmail.test(nextProps.email) ? '' : nextProps.email,
      });
    }
  }

  public render() {
    return (
      <div className={`${this.props.compact ? "cg-col-8 cg-col-xs-24" : `cg-row ${s['c-white-pad']}`} ${s['c-digest']}`}>
        {
          (this.props.error) ?
            <div className={s['c-digest-form']}>
              <span className={s['c-digest-form-title']}>ПОДПИШИТЕСЬ НА НОВОСТНУЮ РАССЫЛКУ</span>
              <span className={`${s['c-digest-form-status']} ${s['c-digest-form-status-fail']}`}>
                Что-то пошло не так, попробуйте подписаться еще раз
              </span>
              <button
                  onClick={() => this.props.onDigestReset()}
                  className={`${s['c-digest-form-button']} ${s['c-digest-form-retry']}`}>
                Повторить
              </button>
            </div>
          : (this.props.isSubscribed) ?
            <div className={s['c-digest-form']}>
              <span className={s['c-digest-form-title']}>ПОДПИШИТЕСЬ НА НОВОСТНУЮ РАССЫЛКУ</span>
              <span className={s['c-digest-form-status']}>Подписка оформлена!</span>
              <span className={s['c-digest-form-info']}>Каждую неделю будем сообщать о важном в мире недвижимости</span>
            </div>
          :
            <div className={s['c-digest-form']}>
              <span className={s['c-digest-form-title']}>ПОДПИШИТЕСЬ НА НОВОСТНУЮ РАССЫЛКУ</span>
              <Tooltip
                  position={0}
                  wrapperStyles={s['c-digest-form-email-container']}
                  tooltipContent={ this.state.emailValid ? '' : 'Укажите email' }>
                <TextField
                    onValueChange={(value: string) => this.onChange(value)}
                    value={this.state.value}
                    inputStyle={s['c-digest-form-email']}
                    type="text"
                    placeholder="Ваш email" />
                </Tooltip>
              <button
                  onClick={() => this.submitEmail()}
                  className={s['c-digest-form-button']}>
                Подписаться
              </button>
              { !this.props.isAuthenticated && DigestForm.renderLicence() }
            </div>
        }
      </div>
    );
  }

  private submitEmail() {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(this.state.value)) {
      this.props.onDigestSubmit(this.state.value)
        .then((data) => {
          if (data.subscribe) {
            trackSubscribe();
          }

          if (data.auth) {
            trackRegistration();
          }
        });
    } else {
      this.showError();
    }
  }

  private onChange(email: string) {
    this.setState({ value: email, emailValid: true });
  }

  private showError = () => {
      this.setState({
        value: this.state.value,
        emailValid: false,
      }, () => {
        document.addEventListener('click', this.hideError);
      });
  }

  private hideError = () => {
      this.setState({
        value: this.state.value,
        emailValid: true,
      }, () => {
        document.removeEventListener('click', this.hideError);
      });
  }
}

export const DigestFormContainer = connect<Pick<IProps, 'isAuthenticated' | 'email'>,
  Pick<IProps, 'onDigestSubmit' | 'onDigestReset'>,
  Pick<IProps, 'compact' | 'isSubscribed' | 'error'>>(
  (state: {
    user: IUser;
  }) => {

    return {
      email: state.user.email || '',
      isAuthenticated: state.user.isAuthenticated,
    };
  },
  (dispatch: Dispatch) => ({
    onDigestSubmit: (email: string) =>  dispatch(submitDigest(email) as any),
    onDigestReset: () => dispatch(digestReset()),
  }),
)(DigestForm);
